import {fetchRouteInformation,
    getFilterData,
    getRouteData,
    updateRouteStatusToReadyForDispatch,
    bulkUpdateRouteStatusToReadyForDispatch} from "../network/DepartNetworkAPI";
import {
    getDataWithExpiry,
    isRouteCacheValid,
    setDataWithExpiry
} from "../../util/CacheManager";
import {ROUTE_DATA_CACHE_KEY} from "../../util/LocalStorageKeys";
import {
    DEPART_TAB_METRIC_KEY,
    logCounterMetric,
    ROUTE_CACHE_HIT_METRIC,
    ROUTE_CACHE_MISS_METRIC
} from "../../util/MetricUtil";
import {getStationCode} from "../../network/NetworkUtil";
import {getRegion} from "../../util/Util";
import {REGION, DEPART_TABLE_ACTIONS} from "../../util/Constants";

export const DepartReducer = (state, action) => {
    switch (action.type) {
        case "LOAD_VIEW":
            const {dispatcher, filterDispatcher, xptNodes, capability, stationConfig} = action.data;
            const metricKey = getRegion() === REGION.IN? DEPART_TAB_METRIC_KEY+"_"+REGION.IN
                :DEPART_TAB_METRIC_KEY;
            //try to load data from cache if xpt filters and ttl is valid.
            if (isRouteCacheValid(xptNodes)) {
                const {cachedData,lastUpdated} = getDataWithExpiry(ROUTE_DATA_CACHE_KEY);
                logCounterMetric(getStationCode(), metricKey, ROUTE_CACHE_HIT_METRIC);
                dispatcher({type: "RECEIVE_DATA",
                    data: {...getRouteData(cachedData.response.routes, capability, stationConfig), lastUpdated: lastUpdated}
                });
                filterDispatcher({type: "RECEIVE_FILTER_DATA", data: getFilterData(cachedData.response.routes, capability)})
                return state
            } else {
                logCounterMetric(getStationCode(), metricKey, ROUTE_CACHE_MISS_METRIC);
            }
            fetchRouteInformation(action.data, capability);
            return state;
        case "RECEIVE_DATA":
            return {...state, ...action.data}
        case "UPDATE_ROUTE_DATA_CACHE":
        {
            setDataWithExpiry(ROUTE_DATA_CACHE_KEY, action.data);
            return state
        }
        case "UPDATE_ROUTE_STATUS": {
            const {dispatcher, routeId, baseUrl, stationConfig} = action.data;
            updateRouteStatusToReadyForDispatch({dispatcher, routeId, baseUrl, stationConfig, additionalData: action.data});
            return state
        }
        case DEPART_TABLE_ACTIONS.BULK_UPDATE_ROUTE_STATUS_MODAL: {
            return {...state, ...action.data};
        }
        case DEPART_TABLE_ACTIONS.BULK_UPDATE_ROUTE_STATUS: {
            const {dispatcher, routeIds, baseUrl, stationConfig} = action.data;
            bulkUpdateRouteStatusToReadyForDispatch({dispatcher, routeIds, baseUrl, stationConfig, additionalData: action.data});
            return state
        }
        case "SUCCESS_NOTIFICATION":
            return {...state, ...action.data};
        case "FAILURE_NOTIFICATION":
            return {...state, ...action.data};
        case "REMOVE_NOTIFICATION":
            const notification = {alert: {}}
            return {...state, ...notification};
        case DEPART_TABLE_ACTIONS.BULK_SUCCESS_NOTIFICATION_UPDATE:
            return {...state, ...action.data};
        case DEPART_TABLE_ACTIONS.CLOSE_BULK_UPDATE_NOTIFICATION:
            const bulkDepartStatus = {bulkDepartStatus: null}
            return {...state, ...bulkDepartStatus};
         default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/components/depart/reducers/DepartReducer.js